/**
 * @generated SignedSource<<c042048d5e6f74f1ab732ad60190ed18>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type jobDetailPage_Query$variables = {
  jobId: number;
};
export type jobDetailPage_Query$data = {
  readonly accountJob: {
    readonly attempts: number;
    readonly blocker: string | null | undefined;
    readonly cancelRequestedAt: any | null | undefined;
    readonly childJobIds: ReadonlyArray<number>;
    readonly createdAt: any | null | undefined;
    readonly currentObject: string | null | undefined;
    readonly errorMessage: string | null | undefined;
    readonly etaSeconds: number | null | undefined;
    readonly finishedAt: any | null | undefined;
    readonly jobId: number;
    readonly kind: string;
    readonly label: string;
    readonly outcome: ReadonlyArray<{
      readonly key: string;
      readonly value: string;
    }>;
    readonly params: any;
    readonly parentJobId: number | null | undefined;
    readonly phase: string | null | undefined;
    readonly queuePosition: number;
    readonly requestedBy: string | null | undefined;
    readonly rowsProcessed: number;
    readonly rowsTotal: number | null | undefined;
    readonly source: string;
    readonly stageLabels: ReadonlyArray<{
      readonly key: string;
      readonly label: string;
      readonly state: string;
    }>;
    readonly stagesDone: ReadonlyArray<string>;
    readonly stagesTotal: number;
    readonly stalled: boolean;
    readonly startedAt: any | null | undefined;
    readonly status: string;
    readonly supersededByJobId: number | null | undefined;
    readonly terminal: boolean;
    readonly typicalSeconds: number | null | undefined;
    readonly unit: string | null | undefined;
  } | null | undefined;
};
export type jobDetailPage_Query = {
  response: jobDetailPage_Query$data;
  variables: jobDetailPage_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "jobId"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "label",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "key",
  "storageKey": null
},
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "jobId",
        "variableName": "jobId"
      }
    ],
    "concreteType": "AccountJob",
    "kind": "LinkedField",
    "name": "accountJob",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "jobId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "kind",
        "storageKey": null
      },
      (v1/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "status",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "phase",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "currentObject",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "rowsProcessed",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "rowsTotal",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "unit",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "errorMessage",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "params",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "source",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "requestedBy",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "parentJobId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "supersededByJobId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "attempts",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "startedAt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "finishedAt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "createdAt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "cancelRequestedAt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "stalled",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "terminal",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "queuePosition",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "blocker",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "stagesTotal",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "stagesDone",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "AccountJobStage",
        "kind": "LinkedField",
        "name": "stageLabels",
        "plural": true,
        "selections": [
          (v2/*: any*/),
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "state",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "AccountJobOutcome",
        "kind": "LinkedField",
        "name": "outcome",
        "plural": true,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "value",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "typicalSeconds",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "etaSeconds",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "childJobIds",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "jobDetailPage_Query",
    "selections": (v3/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "jobDetailPage_Query",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "fcaa2cf878b264afb391cb263bd411c9",
    "id": null,
    "metadata": {},
    "name": "jobDetailPage_Query",
    "operationKind": "query",
    "text": "query jobDetailPage_Query(\n  $jobId: Int!\n) {\n  accountJob(jobId: $jobId) {\n    jobId\n    kind\n    label\n    status\n    phase\n    currentObject\n    rowsProcessed\n    rowsTotal\n    unit\n    errorMessage\n    params\n    source\n    requestedBy\n    parentJobId\n    supersededByJobId\n    attempts\n    startedAt\n    finishedAt\n    createdAt\n    cancelRequestedAt\n    stalled\n    terminal\n    queuePosition\n    blocker\n    stagesTotal\n    stagesDone\n    stageLabels {\n      key\n      label\n      state\n    }\n    outcome {\n      key\n      value\n    }\n    typicalSeconds\n    etaSeconds\n    childJobIds\n  }\n}\n"
  }
};
})();

(node as any).hash = "13bd74a43d6c2324e092de4578a2e2c6";

export default node;
